<aside class="kr-shell__sidebar" krSidebar></aside>

<main class="kr-shell__container container">
  <header class="kr-shell__header" krHeader></header>

  <main class="kr-shell__main">
    <router-outlet></router-outlet>
  </main>
</main>
